import { render, staticRenderFns } from "./tiscOption.vue?vue&type=template&id=4ae883c8&"
import script from "./tiscOption.vue?vue&type=script&lang=js&"
export * from "./tiscOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports